import home from './home.json'
import homeEmbed from './homeEmbed.json'
import homeOrganic from './homeOrganic.json'
import about from './about.json'
import producers from './producers.json'
import affiliates from './affiliates.json'
import solutions from './solutions.json'
import hotmartApp from './hotmartApp.json'
import tour from './tour.json'
import legal from './legal.json'
import payments from './payments.json'
import pricing from './pricing.json'
import newSolutions from './newSolutions.json'

export default {
  home,
  homeEmbed,
  homeOrganic,
  about,
  producers,
  affiliates,
  solutions,
  hotmartApp,
  tour,
  legal,
  payments,
  pricing,
  newSolutions,
}
